import angular from 'angular';
import RetailerDashboardPageComponent from './retailer-dashboard-page-component';

export default angular.module('retailerDashboardPage', [])
  .component('retailerDashboardPage', new RetailerDashboardPageComponent())
;



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/containers/dashboard-page/retailer-dashboard-page-module.js